import { FilterTabEnum, getRetainedAsset, holdingAssetTabs, reportsTabAndDropDownData, switchTabBasedOnDashboardRowClick, tabWithAssetCategory, } from "@frameworks/web/components/Reports/CommonComponent/constant";
import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import DeviceContext from "../../../../../utils/indentifyDevice";
import di from "../../di/servicelocator";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import HoldingReportMobile from "./HoldingReportMobile";
import _ from "underscore";
import { useSelector } from "react-redux";
const HoldingReportComponentMobile = (props) => {
    const navigate = useNavigate();
    const [scrollPosition, setScrollPosition] = React.useState(0);
    const location = useLocation();
    const locationState = location.state;
    const [isInsuranceVisited, setIsInsuranceVisited] = useState(false);
    /**************************redux states******************************* */
    const activeHoldingTabName = useSelector((state) => { var _a; return (_a = state.holdingReport) === null || _a === void 0 ? void 0 : _a.activeAssetTab; });
    /**************************Functions******************************** */
    const onTabchange = (akey) => {
        var _a;
        di.holdingReport.saveProdAssetDropDown((_a = reportsTabAndDropDownData[akey].assetProductList) === null || _a === void 0 ? void 0 : _a[0], akey);
        let selectedAssetCategories = tabWithAssetCategory[akey];
        //if there is asset selected when user is in All tab then apply those asset first
        let retainedAssets = getRetainedAsset(akey);
        if (retainedAssets.length > 0)
            selectedAssetCategories = retainedAssets;
        di.holdingReport.onAssetChange(selectedAssetCategories);
        if (akey === FilterTabEnum.INSURANCE) {
            setIsInsuranceVisited(true);
            di.holdingReport.toggleQtyBreakDown(false); // qty brake downs
        }
        navigate({
            pathname: "",
            search: createSearchParams({
                reportName: "Holding",
                // tab: akey,
            }).toString(),
        });
    };
    const scrollToParticularTab = (elementId) => {
        var _a;
        const element = (_a = document === null || document === void 0 ? void 0 : document.querySelector) === null || _a === void 0 ? void 0 : _a.call(document, `[data-rr-ui-event-key=${elementId === null || elementId === void 0 ? void 0 : elementId.split(" ")[0]}]`);
        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center",
            });
        }
    };
    const handleScroll = () => {
        const position = window.pageYOffset;
        setScrollPosition(position);
    };
    /*****************************UseEffects******************************** */
    useEffect(() => {
        var _a;
        // when user redirect on this page  from  dashboard and refresh
        let assetCategory = null;
        if (locationState === null || locationState === void 0 ? void 0 : locationState.goToHoldingAssetTab)
            assetCategory = (_a = locationState === null || locationState === void 0 ? void 0 : locationState.goToHoldingAssetTab) === null || _a === void 0 ? void 0 : _a.assetCategory;
        //locationState.selectedEle coming from dashboard whn clicked on asset row
        if (assetCategory) {
            let tabDetail = switchTabBasedOnDashboardRowClick(assetCategory);
            // in  tabDetail will get default product  option or all products option  of that assetCategory
            //no need to set Asset type  as it is not used anywhare in holding for Txn
            // on  redirection  tabdetails will return  main Asset
            di.holdingReport.saveProdAssetDropDown(tabDetail.productOption, tabDetail.tabkey);
            let retainedAssets = getRetainedAsset(tabDetail.tabkey);
            di.holdingReport.onAssetChange(retainedAssets.length > 0 ? retainedAssets : [assetCategory], true);
        }
        else {
            //comes when initial render in all tab, for refresh  with no location state,
            // also when back from L3 page
            let retainedAssets = getRetainedAsset(activeHoldingTabName);
            if (activeHoldingTabName === FilterTabEnum.ALL) {
                // for all tab only check whether there is retained Asset ,  yes then apply, no then clear all
                di.holdingReport.onAssetChange(retainedAssets);
            }
            // else condition will handled by redux= stored prodDropdown & activeAssetTab
        }
    }, [locationState]);
    useEffect(() => {
        scrollToParticularTab(activeHoldingTabName);
    }, [activeHoldingTabName]);
    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "tabs_pnl" },
            React.createElement(Tabs, { defaultActiveKey: activeHoldingTabName, onSelect: onTabchange, activeKey: activeHoldingTabName, className: `pnl_tabs ${DeviceContext().isMobile && scrollPosition > 100
                    ? "dock_tabs_mobile"
                    : ""}`, style: DeviceContext().isMobile && scrollPosition > 100
                    ? { top: "63px" }
                    : null }, holdingAssetTabs.map((assetTab) => {
                return (React.createElement(Tab, { eventKey: assetTab.eventKey, title: assetTab.title, id: assetTab.id }, assetTab.eventKey === activeHoldingTabName && (React.createElement(HoldingReportMobile, { openDrawer: props.openDrawer, setOpenDrawer: props.setOpenDrawer, loader: props.loader, setLoader: props.setLoader, keyTab: assetTab.eventKey, assetFilter: reportsTabAndDropDownData[assetTab.eventKey], accCodes: props.accCodes, setIsInsuranceVisited: setIsInsuranceVisited, isInsuranceVisited: isInsuranceVisited }))));
            })))));
};
export default React.memo(HoldingReportComponentMobile, (prev, next) => _.isEqual(prev, next));
